export const NBSP_JS = '\xa0';
